import actions from './constants';

export const datasetAttachmentDownloadSuccess = (category, code, attachment) => ({
  type: actions.DATASET_ATTACHMENT_DOWNLOAD_SUCCESS,
  category,
  code,
  attachment,
});

export const datasetAttachmentDownloadError = (category, code, attachment) => ({
  type: actions.DATASET_ATTACHMENT_DOWNLOAD_ERROR,
  category,
  code,
  attachment,
});

export const showDatasetAttachments = (category, code, result) => ({
  type: actions.FETCH_DATASET_ATTACHMENTS_SUCCESS,
  category,
  code,
  result,
});

export const showDatasetAttachmentsError = (category, code, error) => ({
  type: actions.FETCH_DATASET_ATTACHMENTS_ERROR,
  category,
  code,
  error,
});

export const updateDatasetAttachmentMetadataError = (category, code, attachmentId, error, name) => ({
  type: actions.UPDATE_DATASET_ATTACHMENT_METADATA_ERROR,
  category,
  code,
  attachmentId,
  error,
  name,
});

export const updateDatasetAttachmentMetadataSuccess = (category, code, attachmentId, result) => ({
  type: actions.UPDATE_DATASET_ATTACHMENT_METADATA_SUCCESS,
  category,
  code,
  attachmentId,
  result,
});

export const deleteDatasetAttachmentSuccess = (items) => ({
  type: actions.DELETE_DATASET_ATTACHMENT_SUCCESS,
  items,
});

export const deleteDatasetAttachmentError = (items) => ({
  type: actions.DELETE_DATASET_ATTACHMENT_ERROR,
  items,
});

export const showDatasetAttachmentDictionary = (category, code, dictionary) => ({
  type: actions.SHOW_DATASET_ATTACHMENT_DICTIONARY,
  category,
  code,
  dictionary,
});

export const showDatasetAttachmentDictionaryError = (category, code, error) => ({
  type: actions.SHOW_DATASET_ATTACHMENT_DICTIONARY_ERROR,
  category,
  code,
  error,
});

export const updateDatasetAttachmentDescriptionSuccess = (category, code, attachment) => ({
  type: actions.UPDATE_DATASET_ATTACHMENT_DESCRIPTION_SUCCESS,
  category,
  code,
  attachment,
});

export const updateDatasetAttachmentDescriptionError = (error) => ({
  type: actions.UPDATE_DATASET_ATTACHMENT_DESCRIPTION_ERROR,
  error,
});

export const createDatasetFolderError = (category, code, error) => ({
  type: actions.CREATE_DATASET_ATTACHMENT_FOLDER_ERROR,
  category,
  code,
  error,
});

export const createDatasetFolderSuccess = (category, code, result) => ({
  type: actions.CREATE_DATASET_ATTACHMENT_FOLDER_SUCCESS,
  category,
  code,
  result,
});
